<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">
<div class="wrapperi mb-4">

    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Hinnoittelu</h2>
            <p>Tässä näet asiakkaan yrityksen hinnoittelun.</p>
            <button class="btn btn-formed-main-black" (click)="saveChanges()">Tallenna</button>
        </div>
        <div class="col-1"></div>
    </div>

    <div id="loader" *ngIf="isLoading" class="loader-container mt-4">
        <div class="loader mx-auto"></div>
        <p class="text-center pt-3">Odota...</p>
      </div>
  
  
    <div class="col-12 p-0 row m-0" *ngIf="!isLoading">
      <div class="col-1"></div>
      <div class="col-10 p-0">
        <div class="card formed-shadow">
            <div class="card-header">
                <div class="table-responsive" *ngIf="pricing && pricing.vat; else no_answers_content">
                    <table class="table align-items-center table-flush">
                        <thead class="thead-light">
                            <tr>
                               
                                <th>Nimike</th>
                                <th>Päivä</th>
                                <th>Summa</th>
                            </tr>
                        </thead>
                        <tbody class="tbody-light">
                            <tr>
                                <td>Alv</td>
                                <td></td>
                                <td><input type="number" id="vat" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Perustamismaksu</td>
                                <td></td>
                                <td><input type="number" id="grounding_fee" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Kuukausimaksu</td>
                                <td></td>
                                <td><input type="number" id="monthly_fee" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Käyttäjäkohtainen kuukausimaksu</td>
                                <td></td>
                                <td><input type="number" id="per_user_monthly_fee" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Toimipistekohtainen kuukausimaksu</td>
                                <td></td>
                                <td><input type="number" id="per_subgroup_monthly_fee" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Feed julkaisukustannus</td>
                                <td></td>
                                <td><input type="number" id="feed_feed_publish" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Feed mainos (1pv)</td>
                                <td></td>
                                <td><input type="number" id="feed_feed_ad" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Marketplace ilmoitus</td>
                                <td></td>
                                <td><input type="number" id="market_place_leave" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Marketplace tarjous</td>
                                <td></td>
                                <td><input type="number" id="market_place_bid" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Avoimet ilmoitukset avaus</td>
                                <td><input type="number" id="headhunting_profile_opening_days_valid" class="form-control"></td>
                                <td><input type="number" id="headhunting_profile_opening" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Toivelista profiilinavaus</td>
                                <td><input type="number" id="wishlist_profile_days_valid" class="form-control"></td>
                                <td><input type="number" id="wishlist_profile_opening" class="form-control"></td>
                            </tr>
                            <tr>
                                <td>Profiilin avaus</td>
                                <td><input type="number" id="application_profile_days_valid" class="form-control"></td>
                                <td><input type="number" id="application_profile_opening" class="form-control"></td>
                            </tr>
                            
                        </tbody>
      
                    </table>
                </div>
                <ng-template #no_answers_content>
                    <div class="col-12 row m-0">
                        <div class="col-3"></div>
                        <div class="col-12 col-md-6">
                            <div class="alert alert-warning">
                                <p class="normal-text text-center">Yritykselle ei ole vielä tehty hinnoittelumallia</p>
                            </div>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </ng-template>
            </div>
            
        </div>
      </div>

        <div class="col-1"></div>
  </div>


    </div>
    </div>
</div>